import { viewH5FileMethods } from "@/CommonDP/utils/docPublic";
import * as uni from "@/CommonDP/mongeView/appView/component/uni.webview.1.5.2";
import routerInit from "@/CommonDP/router";

/**
 * 最新的app端文件预览
 * @param row --必填
 * @param row.fileType 文件类型 --必填
 * @param data.fileId 文件id:(模型：fileIds)--必填
 * @param data.versionId 文件版本：(模型：versionIds)--必填
 * @param data.questionId 问题id：定位问题
 * @param data.noNeedIssue 是否有批注：(true:隐藏；不填显示)
 * @param data.sharerId 分享人的用户id： -- 分享使用
 * @param data.enterpriseId 企业id -- 分享使用
 * @param data.i  分享标识-- 分享使用
 * @param data.isLoginFree  手机端是否使用分享的接口（true：是）-- 分享使用
 * @param data.flowInstanceId  流程使用
 * @param data.qmType 意见类型 -- 项目里的校审区和校审流程里的文件使用
 */
export function viewAppFileMethods(row, data) {
  const { fileId, versionId } = data;
  const params = { ...row, ...data, fileIds: fileId, versionIds: versionId };
  const store = require("@/store/index").default;
  const { isWebView } = store.state.app;
  if (isWebView) {
    // app的webview调用
    const message = { source: "preview", params };
    uni.postMessage({ data: message });
  } else {
    // 外部H5环境，直接走viewH5FileMethods
    viewH5FileMethods(row, data);
  }
}

// app端返回H5回退方法
export function appBackMethods() {
  const store = require("@/store/index").default;
  const { isWebView } = store.state.app;
  if (isWebView) {
    // app的webview调用
    const message = { source: "back" };
    uni.postMessage({ data: message });
  } else {
    // 外部H5环境，直接走viewH5FileMethods
    const router = routerInit();
    router.back();
  }
}

// app端返回H5关闭窗口
export function appBackWindow() {
  // #ifdef APP-PLUS
  window.history.go(-1);
  // #endif
  // #ifdef H5
  window.close();
  // #endif
}
